import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import ErrorComponentPage from "./ErrorComponentPage";
import ErrorRoutePage from "./ErrorRoutePage";

interface ErrorBoundaryComponentProps {
  status?: number
}

const ErrorBoundaryComponent = ({
  status = 500
}: ErrorBoundaryComponentProps) => {
  const error = useRouteError();

  // More info: https://stackoverflow.com/a/78954723

  return isRouteErrorResponse(error) ? 
    <ErrorRoutePage /> : <ErrorComponentPage status={status}/>
}

export default ErrorBoundaryComponent;